import { useEffect, useCallback, useRef } from 'react';

export const useDetailsPageSetup = ({
  currentItemId,
  folderAssetType,
  logger,
  navigation,
  totalAssetCount,
  assets,
  loadMoreData,
  renameAsset,
  onClose,
}) => {
  const reloadLandingPageRef = useRef(false);

  useEffect(() => {
    logger.logTrace('Item Details: page loaded', { currentItemId, folderAssetType });
  }, [currentItemId, folderAssetType, logger]);

  const navigateToFallbackPage = useCallback(() => {
    logger.logTrace('Item Details: no info, redirect to landing page');
    navigation.gotoLandingPage({ redirect: true });
  }, [logger, navigation]);

  const navigateToOtherItem = useCallback(({
    id: otherItemId,
    folderAssetType: otherItemFolderAssetType,
  }) => {
    navigation.gotoAssetDetails({
      assetId: otherItemId, folderAssetType: otherItemFolderAssetType, assets, totalAssetCount, loadMoreData, renameAsset, onClose,
    });
  }, [assets, loadMoreData, navigation, onClose, renameAsset, totalAssetCount]);

  const onDismissed = useCallback(() => {
    navigation.goBack({ reload: reloadLandingPageRef.current });
  }, [navigation]);

  return {
    navigateToFallbackPage,
    navigateToOtherItem,
    onDismissed,
    reloadLandingPageRef,
  };
};
